import { render, staticRenderFns } from "./PlaylistPage.vue?vue&type=template&id=9458d022&scoped=true&"
import script from "./PlaylistPage.vue?vue&type=script&lang=js&"
export * from "./PlaylistPage.vue?vue&type=script&lang=js&"
import style0 from "./PlaylistPage.vue?vue&type=style&index=0&id=9458d022&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9458d022",
  null
  
)

export default component.exports